import TaggedImage from "./TaggedImage";

export default TaggedImage;
